import api from "./apiURL";
export async function getBlockedNumbersList() {
  try {
    const response = await api.get(`/api/v1/blockedNumber/getAll`);
    return response.data;
  } catch (error) {
    // Handle the error
    console.log(error);
  }
}

export async function addBlockedNumber(data) {
  try {
    const response = await api.post(`/api/v1/blockedNumber/add`, data);
    return response.data;
  } catch (error) {
    // Handle the error
    console.log(error);
  }
}

export async function removeBlockedNumber(id) {
  try {
    const response = await api.delete(`/api/v1/blockedNumber/delete/?id=${id}`);
    return response.data;
  } catch (error) {
    // Handle the error
    console.log(error);
  }
}
